import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import WeddingApp from "./WeddingApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WeddingApp />
  </React.StrictMode>
);
